import st from './CSelect.module.scss';
import { optionType } from "./types/optionTypes";
import React, { useEffect, useRef, useState } from "react";

type CSelectType = {
    name?: string;
    onChange?: (obj: any) => void;
    values?: Array<optionType>;
    value?: string | Array<string> | number | null;
    hasError?: boolean;
    placeHolder?: string;
    anotherClasses?: string;
    isMultiply?: boolean;
    renderOptionValue?: any;
    isSelect2?: boolean;
    isDisabled?: boolean;
    isReadOnly?: boolean;
}
type EventObjectType = {
    target: TargetType
}
type TargetType = {
    name: string,
    value: any,
}

const CSelect = ({
    name = '',
    onChange,
    values,
    value,
    anotherClasses,
    hasError,
    placeHolder = 'Select',
    isMultiply = false,
    renderOptionValue,
    isSelect2 = false,
    isDisabled = false, isReadOnly = false
}: CSelectType) => {

    let EventObject: EventObjectType = { target: { name: name, value: isMultiply ? [] : "" } };
    const [fullValues, setFullValues] = useState(values);
    const [filteredValues, setFilteredValues] = useState(values);
    const newRef = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const [filterText, setFilter] = useState('');
    const handleOutsideClick = (e: any) => {
        let time: any = newRef.current;
        if (time && !time.contains(e.target)) {
            setOpen(false);
        }
    };
    const [isDown, setIsDown] = useState(false);

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });
    useEffect(() => {
        setFullValues(values);
        filterValue();
    }, [values]);
    useEffect(() => {
        filterValue();
    }, [fullValues]);


    const filterValue = () => {
        let time: any[] = [];
        fullValues?.forEach((item) => {
            if (item.name.toLowerCase().includes(filterText.toLowerCase())) {
                time.push(item);
            }
        })
        setFilteredValues(time);
    }
    useEffect(() => {
        filterValue();
    }, [filterText])

    const showedValue = () => {
        if (values) {
            if (Array.isArray(value)) {
                let val: any[] = [];
                values.forEach((item) => {
                    if (value?.includes(item.id) || value?.includes(item.id.toString())) {
                        renderOptionValue ? val.push({ render: renderOptionValue(item), item: item }) : val.push({ render: false, item: item });
                    }
                })
                return (
                    val.map((item) => {
                        return <span key={'_selected' + item.item.name + item.item.id} className={st.selectedItem}>{item.render ? item.render : item.item.name}
                            <svg style={{ cursor: "pointer", width: "10px" }} onClick={(e) => {
                                e.bubbles = false;
                                e.preventDefault();
                                e.stopPropagation();
                                if (Array.isArray(values)) {
                                    let position = values.indexOf(item.item.id);
                                    value.splice(position, 1);
                                    EventObject.target.value = value;
                                    if (typeof onChange != "undefined") {
                                        onChange(EventObject);
                                    }
                                }
                            }}
                                fill-rule="evenodd" viewBox="64 64 896 896" focusable="false" data-icon="close"
                                width="1em"
                                height="1em" fill="currentColor" aria-hidden="true">
                                <path
                                    d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path>
                            </svg>

                        </span>;
                    })
                );
            } else {
                let val = '';
                values.forEach((item) => {
                    if (item.id === value) {
                        renderOptionValue ? val = renderOptionValue(item) : val = item.name;
                    }
                })
                return val;
            }
        } else {
            return '';
        }
    }

    return (
        <div className={st.root + ((hasError) ? ' ' + st.error : '') + ' ' + ((isReadOnly || isDisabled) ? st.off : "") + ' ' + anotherClasses}
            ref={newRef} onClick={(e) => {
                if (isReadOnly || isDisabled) {
                    return false;
                }
                if (newRef?.current) {
                    let oftop = (newRef.current as any).offsetTop;
                    if (oftop > window.scrollY + window.innerHeight / 2) {
                        setIsDown(false);
                    } else {
                        setIsDown(true);
                    }
                    //window.scrollY
                    // window.innerHeight
                }
                if (e.target && isMultiply) {
                    let t = e.target as HTMLElement;
                    if (!t.classList.contains(st.option) && !isDisabled) {
                        setOpen(!isOpen);
                    }
                } else {
                    if (!isReadOnly && !isDisabled) {
                        setOpen(!isOpen);
                    }
                }

                if (!isOpen) {
                    setFilter('');
                }
            }}>
            <div className={st.val + (isOpen ? ' ' + st.opened : '')}><span
                className={st.placeholder + (value !== '' && value !== '-' ? ' ' + st.hidden : '')}>{placeHolder}</span>{showedValue()}
                {isSelect2 && isOpen ? (
                    <>
                        <input type={'text'} onChange={(obj) => {
                            setFilter(obj.target.value);
                        }} className={isMultiply ? st.select2Input : st.selectInput}
                            autoFocus={true} value={filterText} />
                    </>) : (<></>)}
            </div>


            <div
                className={st.selectOptions + ' ' + (isDown ? "" : st.selectOptions_up) + ' ' + (!isOpen ? st.hidden : '')}>
                <div className={st.option} key={'-'} onClick={() => {
                    EventObject.target.value = '-';
                    if (typeof onChange != "undefined") {
                        onChange(EventObject);
                    }
                }}>-
                </div>
                {filteredValues && filteredValues.length > 0 && filteredValues.map((item: optionType) =>
                    <div
                        className={st.option + ((Array.isArray(value) && (value.includes(item.id) || value?.includes(item.id.toString()))) ? ' ' + st.option_selected : "")}
                        key={item.id} onClick={() => {
                            if (typeof onChange != "undefined") {
                                if (!isMultiply) {
                                    EventObject.target.value = item.id;
                                    onChange(EventObject);
                                } else {
                                    // console.log({filteredValues,value})
                                    if (Array.isArray(value)) {
                                        let position = value.indexOf(item.id);
                                        if (position === -1) {
                                            value.push(item.id);
                                            EventObject.target.value = value;
                                        } else {
                                            value.splice(position, 1);
                                            EventObject.target.value = value;
                                        }
                                        onChange(EventObject);
                                    }
                                    if (typeof value === "string") {
                                        EventObject.target.value = value;
                                        onChange(EventObject);
                                    }
                                }
                            }
                        }}>
                        {renderOptionValue ? renderOptionValue(item) : item.name}
                    </div>
                )}
            </div>
        </div >
    )
}

export default CSelect;